const TESTIMONIALS = [
    {
        quote:
            "Cheguei me sentindo perdida em uma fase muito difícil do meu casamento. As sessões com a Luara me devolveram a coragem de olhar para mim, sem culpa. Hoje, nosso vínculo é outro.",
        author: "A. M.",
        context: "Terapia de casal · 1 ano de acompanhamento",
    },
    {
        quote:
            "A ansiedade ocupava todo o meu dia. Encontrei na Luara uma escuta serena e um método que de fato funciona. Pela primeira vez em anos, sinto que respiro.",
        author: "R. F.",
        context: "Psicoterapia individual · adulto",
    },
    {
        quote:
            "Procurei terapia para entender por que repetia os mesmos padrões nos relacionamentos. O processo foi profundo, respeitoso e muito transformador.",
        author: "C. S.",
        context: "Psicoterapia individual · adulto",
    },
];

export const Testimonials = () => {
    return (
        <section id="depoimentos" data-testid="testimonials-section" className="py-24 lg:py-32 bg-[#D8B7B1]/30 relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="max-w-2xl mb-16 reveal">
                    <p className="overline mb-5">Histórias que se transformam</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2F2F2F]">
                        Relatos de quem
                        <span className="italic text-[#9f1e1e]"> caminhou um pouco mais leve.</span>
                    </h2>
                    <p className="mt-6 text-sm text-[#2F2F2F]/65 italic">
                        Em respeito ao sigilo profissional, os depoimentos são apresentados apenas com iniciais
                        e contexto, conforme o Código de Ética da Psicologia.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#B7A6B0]/30 border border-[#B7A6B0]/30">
                    {TESTIMONIALS.map((t, i) => (
                        <div
                            key={t.author + i}
                            data-testid={`testimonial-${i}`}
                            className="bg-[#F5F4F2] p-10 lg:p-12 relative reveal"
                        >
                            <span
                                aria-hidden
                                className="absolute top-6 left-8 font-display text-[5rem] leading-none text-[#9f1e1e]/15 select-none"
                            >
                                “
                            </span>
                            <p className="relative font-display italic text-xl lg:text-[1.4rem] leading-snug text-[#2F2F2F]/90 mt-8">
                                {t.quote}
                            </p>
                            <div className="mt-8 pt-6 border-t border-[#B7A6B0]/50">
                                <p className="overline text-[10px] mb-1">{t.author}</p>
                                <p className="text-xs text-[#2F2F2F]/65">{t.context}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
